export default __webpack_public_path__ + "static/media/FoodStore_15.50a29fb0.png";